import revive_payload_client_4sVQNw7RlN from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import utils_EEhlE5KdlH from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/plugins/utils.ts";
import vuetify_7h9QAQEssH from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/plugins/vuetify.ts";
import writeExcelFile_jsoHjR5Omy from "/builds/hermesintl/retail/devis-maison/devis-maison-front/src/plugins/writeExcelFile.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  utils_EEhlE5KdlH,
  vuetify_7h9QAQEssH,
  writeExcelFile_jsoHjR5Omy
]